module.exports = __webpack_public_path__ + "img/fundingProtectLogo3.43939de3.png";